import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
	.kog-area-textToCopy {
		max-width: 1000px;
		align-items: center;
	}
`;

export const HeaderText = styled.p`
	color: #9f9f9f;
	font-size: 1rem;
	font-weight: bold;
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;
	}
`;

export const FooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	> button {
		max-width: 200px;
	}
`;
